export default __webpack_public_path__ + "static/media/words8.95b38824.png";